import {useMatch} from "react-router";
// catRoutes, not routes: the merged map pulls in the env config through sitRoutes.
import {catRoutes} from "~/routing/catRoutes";

/**
 * Where the chat is shown, read from the route: the Dashboards gallery, one dashboard (both with
 * the chat docked in the Atlas panel), or anywhere else (the chat page, the home box).
 */
export type ChatSurface = "dashboards" | "dashboard" | "chat";

export function useChatSurface(): ChatSurface {
    const onGallery = useMatch(catRoutes.dashboards) != null;
    const onDashboard = useMatch(catRoutes.dashboards_detail) != null;
    if (onDashboard) return "dashboard";
    if (onGallery) return "dashboards";
    return "chat";
}

/** The empty-chat greeting for each surface. */
export const CHAT_GREETINGS: Record<ChatSurface, string> = {
    dashboards: "Describe the dashboard you need and Atlas will build it.",
    dashboard: "Tell Atlas what to change on this dashboard.",
    chat: "Ask questions, explore your spend, or request insights.",
};

/** The agent's starter prompts under the composer belong to the chat, not to the Dashboards module. */
export const showsAgentTemplates = (surface: ChatSurface) => surface === "chat";
